import {
  startOfWeek,
  endOfWeek,
  compareAsc,
  differenceInDays,
  format,
} from "date-fns";
import { enGB, enUS } from "date-fns/locale";

// Datetime Configurations: >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

export const datetimeConfigs = {
  // datetimes
  dt_full: "PPPP 'at' h:mmaaa", // Monday, May 30th, 2022 at 3:14pm
  dt_medium: "dd/MM/yy, h:mmaaa", // 30/05/22, 3:14pm
  dt_short: "dd/MM, h:mmaaa", // 30/05, 3:14pm
  dt_short_variant: "EEE/h:mmaaa",
  // times
  t_short: "HH:mm", // 15:14
  // dates
  d_full: "dd/MM/yyyy", // 30/05/2022
  d_full_variant: "yyyy-MM-dd", // 2022-05-30
  d_medium: "dd/MM/yy", // 30/05/22
  d_short: "dd / MM", // 30/05
  d_day_short: "EEE", // Mon
  d_year_full: "yyyy", // 2022
};

// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

// Calendar Helpers >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

export const getStartOfWeek = (date = new Date()) => {
  // Returns full format date of Monday relative to current date
  let weekStartDate = startOfWeek(date, { weekStartsOn: 1 });
  return weekStartDate;
};

export const getEndOfWeek = (date = new Date()) => {
  // Returns full format date of Sunday relative to current date
  let weekEndDate = endOfWeek(date, { weekStartsOn: 1 });

  return weekEndDate;
};

// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
// Calendar Helpers <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

// Reminder Helpers >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
export const processReminder = (info) => {
  // Determines whether a reminder note date is close to expiring or has
  // already expired.

  let today = new Date();
  today.setHours(0, 0, 0, 0);

  let reminderDate = new Date(info.value);
  reminderDate.setHours(0, 0, 0, 0);

  if (!reminderDate) {
    return null;
  }

  let dateComparison = compareAsc(reminderDate, today);
  let diffInDays = Math.abs(differenceInDays(today, reminderDate));

  let reminderNote = {
    daysToGo: diffInDays,
    title: info.title,
    show: info.show,
    uid: info.uid,
    expired: false,
    warning: false,
    text: "default",
  };

  switch (dateComparison) {
    case 0: {
      // Matches

      reminderNote.expired = true;
      reminderNote.daysToGo = 0;

      reminderNote.text = "Expired";

      break;
    }
    case 1: {
      // Not Expired

      if (diffInDays < 8) {
        // If within 1 week of expiry
        reminderNote.warning = true;
        reminderNote.text = `Danger Pete Henderson! Expires in ${diffInDays} day${
          diffInDays > 1 ? "s" : ""
        }`;
      }

      break;
    }
    case -1: {
      // Expired

      reminderNote.expired = true;
      reminderNote.daysToGo = 0;
      reminderNote.text = "Expired";

      break;
    }
    default: {
      reminderNote.warning = false;
      reminderNote.expired = false;
    }
  }

  return reminderNote;
};
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
// Reminder Helpers <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

// New Datetime functions >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
export const dateTimeFormatter = (
  d,
  dtConfig = "dt_short",
  fallback = "--"
) => {
  if (!d) return fallback;
  try {
    let inputDatetime = new Date(d);

    let formattedDatetime = format(inputDatetime, datetimeConfigs[dtConfig], {
      locale: enUS,
    });

    return formattedDatetime || fallback;
  } catch (e) {
    return fallback;
  }
};
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

// Acountants >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

export const quarterMonthBookends = {
  1: [1, 3],
  2: [4, 6],
  3: [7, 9],
  4: [10, 12],
};

export const monthQuarters = {
  1: "1",
  2: "1",
  3: "1",
  4: "2",
  5: "2",
  6: "2",
  7: "3",
  8: "3",
  9: "3",
  10: "4",
  11: "4",
  12: "4",
};

export function getEndOfMonth(monthIndex, year) {
  function isLeapYear() {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  const monthDay = {
    1: "31",
    2: isLeapYear() ? "29" : "28",
    3: "31",
    4: "30",
    5: "31",
    6: "30",
    7: "31",
    8: "31",
    9: "30",
    10: "31",
    11: "30",
    12: "31",
  };

  return monthDay[Number(monthIndex)];
}

export const startOfQuarters = {
  1: "00",
  2: "03",
  3: "06",
  4: "09",
};

export const endOfQuarters = {
  1: "02",
  2: "05",
  3: "08",
  4: "11",
};

export const quartersAvailable = [
  { monthNumber: 1, description: "1st : Jan - Mar" },
  { monthNumber: 2, description: "2nd : Apr - Jun" },
  { monthNumber: 3, description: "3rd : Jul - Sept" },
  { monthNumber: 4, description: "4th : Oct - Dec" },
];
